import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import DialogSearch from '@/components/DialogSearch/DialogSearch';
import InputText from '@/components/UI/InputText/InputText';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import { TEAMS_PERSON, fieldTypes } from '@/helpers/constants';
import useWarningField from '@/hooks/useWarningField';
import { UserSearch } from '@/types';

const useStyles = makeStyles(() => ({
  userInput: {
    width: '100%',
  },
}));

type InputUserProps = {
  disabled?: boolean;
  id: string;
  label?: string | ReactNode;
  formControlClass?: string;
  value?: string;
  updateUserSelected?: (userSelected: UserSearch | null) => void;
  code?: string;
  title: string;
  level?: number;
  isFixedLevel?: boolean;
  isMandatory?: boolean;
  invalid?: boolean;
  clear?: () => void;
  tooltipTitle?: string;
  isSupplier?: boolean;
  plant?: string;
  authorizedPlants?: boolean;
  fieldPath?: string[];
  userFieldPath?: string[];
  otherConditionInvalid?: { and: boolean; condition: boolean };
  helperText?: string[];
  noSaveField?: boolean;
};

const getTooltipTitle = (value, code) => (code ? `${value}, ${code}` : value);
const InputUser: React.FC<InputUserProps> = (props) => {
  const { disabled, id, label, formControlClass = '', value = '', updateUserSelected = () => { }, code, title, level,
    isFixedLevel, isMandatory = false, invalid, clear, tooltipTitle = getTooltipTitle(value, code), isSupplier, plant,
    authorizedPlants, fieldPath, userFieldPath, otherConditionInvalid, helperText = [], noSaveField = false } = props;
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const url = `${TEAMS_PERSON}${code}`;
  const classes = useStyles();
  const inputStyles = `align-items-center ${formControlClass} ${classes.userInput}`;
  const warning = useWarningField(fieldPath, fieldTypes.INPUT_USER, otherConditionInvalid) || invalid;

  const forceBlurSupplierInput = () => document.getElementById('supplier-id')?.blur();

  useEffect(() => {
    if (isSupplier) forceBlurSupplierInput();
  }, [isOpen]);

  return (
    <>
      <TooltipComponent title={tooltipTitle}>
        <span>
          <InputText
            invalid={warning}
            disabled={disabled}
            id={id}
            label={label}
            fieldPath={fieldPath}
            userFieldPath={userFieldPath}
            value={value}
            onClick={() => setOpen(true)}
            formControlClass={inputStyles}
            urlTeams={url}
            icoSearch
            icoTeams={!isSupplier}
            isMandatory={isMandatory}
            clear={clear}
            autoComplete="off"
            isUserInput
            helperText={helperText}
          />
        </span>
      </TooltipComponent>
      {isOpen
        && (
          <DialogSearch
            isRemote
            isSupplier={isSupplier}
            defaultValue={code}
            level={level}
            isFixedLevel={isFixedLevel}
            title={title}
            plant={plant}
            authorizedPlants={authorizedPlants}
            close={() => setOpen(false)}
            updateOptionSelected={(userSelected) => updateUserSelected(userSelected)}
            saveButtonLabel={noSaveField ? t('dialog.ok') : undefined}
          />
        )}
    </>
  );
};

export default InputUser;
